/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Triple_Coin_Item_NameInputs */

const en_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× Focus Coins`)
};

const ar_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× عملات التركيز`)
};

const de_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× Fokus-Münzen`)
};

const es_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× Monedas de concentración`)
};

const fr_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× Pièces de concentration`)
};

const it_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× Monete di Concentrazione`)
};

const ja_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中コイン3倍`)
};

const ko_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 코인 3배`)
};

const pt_br_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× Moedas de Foco`)
};

const ru_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× монеты за фокус`)
};

const th_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เหรียญโฟกัส 3 เท่า`)
};

const tr_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3× Odaklanma Jetonu`)
};

const zh_cn_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专注金币 3 倍`)
};

const zh_tw_triple_coin_item_name = /** @type {(inputs: Triple_Coin_Item_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專注金幣 3 倍`)
};

/**
* | output |
* | --- |
* | "3× Focus Coins" |
*
* @param {Triple_Coin_Item_NameInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const triple_coin_item_name = /** @type {((inputs?: Triple_Coin_Item_NameInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Triple_Coin_Item_NameInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_triple_coin_item_name(inputs)
	if (locale === "ar") return ar_triple_coin_item_name(inputs)
	if (locale === "de") return de_triple_coin_item_name(inputs)
	if (locale === "es") return es_triple_coin_item_name(inputs)
	if (locale === "fr") return fr_triple_coin_item_name(inputs)
	if (locale === "it") return it_triple_coin_item_name(inputs)
	if (locale === "ja") return ja_triple_coin_item_name(inputs)
	if (locale === "ko") return ko_triple_coin_item_name(inputs)
	if (locale === "pt_br") return pt_br_triple_coin_item_name(inputs)
	if (locale === "ru") return ru_triple_coin_item_name(inputs)
	if (locale === "th") return th_triple_coin_item_name(inputs)
	if (locale === "tr") return tr_triple_coin_item_name(inputs)
	if (locale === "zh_cn") return zh_cn_triple_coin_item_name(inputs)
	return zh_tw_triple_coin_item_name(inputs)
});